const maxRoutesShown = 8

const routesHistoryWidgetConstants = { maxRoutesShown }

export default routesHistoryWidgetConstants
